"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_ButtonIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_ButtonIcon = (0, _styledComponents["default"])('button')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    background: ", ";\n    border: ", ";\n    box-shadow: ", ";\n    border-radius: var(--border-radius-full);\n    padding: ", ";\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: ", ";\n    height: ", ";\n    transition: ", ";\n\n    &:focus {\n        outline: transparent;\n        background: ", ";\n    }\n"])), function (props) {
  if (props.background === 'primary') {
    return 'var(--color-primary)';
  } else if (props.background === 'secondary') {
    return 'var(--color-secondary)';
  } else {
    return 'var(--color-base-white)';
  }
}, function (props) {
  return props.service ? '1px solid var(--color-blue-300)' : 'transparent';
}, function (props) {
  return props.service ? '-3px 3px 2px rgba(10, 109, 215, 0.15)' : 'var(--box-shadow-sm)';
}, function (props) {
  return props.service ? '25px' : '8px';
}, function (props) {
  if (props.service) {
    return '55px';
  } else if (props.size === 'xs') {
    return 'calc(var(--font-size-xs) * 1.25)';
  } else if (props.size === 'sm') {
    return 'calc(var(--font-size-sm) * 1.25)';
  } else if (props.size === 'md') {
    return 'calc(var(--font-size-md) * 1.25)';
  } else if (props.size === 'lg') {
    return 'calc(var(--font-size-lg) * 1.25)';
  } else if (props.size === 'xl') {
    return 'calc(var(--font-size-xl) * 1.25)';
  } else if (props.size === 'xxl') {
    return 'calc(var(--font-size-xxl) * 1.25)';
  }
}, function (props) {
  if (props.service) {
    return '55px';
  } else if (props.size === 'xs') {
    return 'calc(var(--font-size-xs) * 1.25)';
  } else if (props.size === 'sm') {
    return 'calc(var(--font-size-sm) * 1.25)';
  } else if (props.size === 'md') {
    return 'calc(var(--font-size-md) * 1.25)';
  } else if (props.size === 'lg') {
    return 'calc(var(--font-size-lg) * 1.25)';
  } else if (props.size === 'xl') {
    return 'calc(var(--font-size-xl) * 1.25)';
  } else if (props.size === 'xxl') {
    return 'calc(var(--font-size-xxl) * 1.25)';
  }
}, function (props) {
  return props.service && 'background 0.2s ease-in';
}, function (props) {
  return props.service && 'var(--color-gray-200)';
});
exports.Occ_ButtonIcon = Occ_ButtonIcon;